<template>
  <div class="flex flex-col justify-between text-center">
    <div class="w-full bg-beige-academy-300 text-white text-center relative
    font-bold tracking-widest uppercase py-6 text-lg mb-8 flex justify-end items-center">
      <h1 class="absolute w-full text-center"> {{ $t('bookingSlots.pending') }} </h1>
      <button @click.prevent="$modal.hide('locked-slot')" class="px-4 z-20">
        <close-icon />
      </button>
    </div>
    <div class="md:w-3/4 w-5/6 mx-auto flex flex-col justify-between text-lg mb-8"
      v-if="selectedSlot.student">
      <div class="mb-2">
        {{ $t('bookingSlots.student') }}
        <button class="font-bold" @click="loadDashboard(selectedSlot.student, false)">
          {{ selectedSlot.student.name }}
        </button>
        {{ $t('bookingSlots.notComplete') }}
      </div>
      <div class="py-8">
        <button
          @click="makeSlotFree"
          class="md:px-6 px-5 py-3 rounded border bg-background-academy border-background-academy
          uppercase hover:bg-white text-white hover:text-background-academy
          font-bold cursor-pointer">
            {{ $t('bookingSlots.free') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import CloseIcon from '../graphics/CloseIcon.vue';

export default {
  components: { CloseIcon },
  props: ['selectedEvent', 'selectedSlot'],

  mixins: [StreamFunctionsMixin],

  methods: {
    makeSlotFree() {
      axios.put(`/api/slots/${this.selectedSlot.id}/free`).then(() => {
        this.$modal.hide('locked-slot');
        this.$emit('updated');
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorTryAgain'));
      });
    },
  },
};
</script>
